var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "newIccStyles", attrs: { id: "contentParent" } },
    [
      _vm.hasError
        ? _c("div", { staticClass: "error--text" }, [
            _c("p", [_vm._v(_vm._s(_vm.errorMessage))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.contentSections.length && _vm.xmlIds.length && !_vm.isLoading
        ? _c("div", [
            _c("p", [
              _vm._v("No content found for query "),
              _c("b", [_vm._v('"' + _vm._s(_vm.xmlIds) + '"')]),
            ]),
          ])
        : _c(
            "div",
            _vm._l(_vm.contentSections, function (contentSection) {
              return _c("content-section", {
                key: contentSection.sectionId,
                attrs: {
                  contentSection: contentSection,
                  contentModifiers: _vm.createContentModifiers(),
                },
                on: { "breadcrumb-clicked": _vm.handleBreadcrumbClick },
              })
            }),
            1
          ),
      _vm._v(" "),
      _c("peak-ahead"),
      _vm._v(" "),
      _c("astm-modal"),
      _vm._v(" "),
      _c("note-bookmark-modals"),
      _vm._v(" "),
      _c("premium-tools-access-restriction-modal"),
      _vm._v(" "),
      _c("toolbar-actions-view-mobile"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }